export default function CIdentifvariableNames() {
  return <h2>C Identifvariable Names</h2>;
}
